import React, { useEffect, useState, useCallback } from 'react';
import { callsAPI } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';
import { useChat } from '../../context/ChatContext';
import { formatChatDate } from '../../utils/helpers';
import Avatar from '../UI/Avatar';

export default function CallsTab({ onStartCall }) {
  const { user }               = useAuth();
  const { conversations }      = useChat();
  const [calls, setCalls]      = useState([]);
  const [loading, setLoading]  = useState(true);

  const loadCalls = useCallback(async () => {
    try {
      const res = await callsAPI.history();
      if (res.data.success) setCalls(res.data.data.calls);
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => {
    loadCalls();
    // Refresh call log every 10s so new entries appear without reopening tab
    const iv = setInterval(loadCalls, 10000);
    return () => clearInterval(iv);
  }, [loadCalls]);

  if (loading) return <div style={{ padding: 24, textAlign: 'center' }}><div className="spinner" /></div>;

  return (
    <div style={{ flex: 1, overflowY: 'auto' }}>
      <div style={{ padding: '12px 16px 4px', fontSize: 12, fontWeight: 700, color: '#667781', textTransform: 'uppercase', letterSpacing: '.5px' }}>
        Recent Calls
      </div>

      {calls.length === 0 && (
        <div className="empty-state">
          <span className="icon">📞</span>
          <h3>No recent calls</h3>
          <p>Start a call from any chat</p>
        </div>
      )}

      {calls.map(call => {
        const isMine   = call.caller_id == user?.id;
        const statusIcon = {
          missed:   '📵',
          answered: isMine ? '📤' : '📥',
          declined: '❌',
          ongoing:  '🔄',
        }[call.status] || '📞';

        const statusColor = call.status === 'missed' || call.status === 'declined' ? '#E74C3C' : '#25D366';

        const conv = conversations.find(c => c.id == call.conversation_id);
        const other = conv?.other_user || { name: call.caller_name, avatar: call.caller_avatar };

        const dur = call.duration
          ? `${Math.floor(call.duration / 60)}:${String(call.duration % 60).padStart(2,'0')}`
          : '';

        return (
          <div key={call.id} className="conv-item">
            <Avatar user={other} size={48} />
            <div className="conv-info">
              <div className="conv-top">
                <span className="conv-name" style={{ color: call.status === 'missed' ? '#E74C3C' : 'inherit' }}>
                  {other.name}
                </span>
                <span className="conv-time">{formatChatDate(call.started_at)}</span>
              </div>
              <div className="conv-bottom">
                <span className="conv-preview">
                  {statusIcon} {call.type === 'video' ? '📹 Video' : '🎤 Voice'} call
                  {dur ? ` • ${dur}` : ''}
                </span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 4 }}>
              {conv && (
                <>
                  <button className="icon-btn dark" title="Voice call" onClick={() => onStartCall(conv, 'voice')}>📞</button>
                  <button className="icon-btn dark" title="Video call" onClick={() => onStartCall(conv, 'video')}>📹</button>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
